import styled from 'styled-components'

import { shouldUseWhiteText } from '@helper/color'

export const Root = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 24px;
`

export const ServiceItem = styled.li`
  padding: 24px;
  width: calc(100% / 3);

  @media (max-width: ${({ theme }) => theme.device.tablet}) {
    width: 50%;
  }

  @media (max-width: ${({ theme }) => theme.device.mobile}) {
    width: 100%;
  }
`

export const ServiceImage = styled.img`
  border-radius: 30px;
  width: 75%;
`

interface ServiceLinkProps {
  neutral?: boolean
  color: string
}

export const ServiceLink = styled.a<ServiceLinkProps>`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 1.5rem 0.6875rem 1.5rem;
  text-align: center;
  background-color: ${(props) => props.theme.palette.default.greyLight};
  color: ${(props) =>
    shouldUseWhiteText(props.theme.palette.default.grey) ? 'white' : 'black'};
  text-decoration: none;
  border-radius: 30px;
  font-size: 1rem;
  line-height: 1.25rem;
  text-transform: uppercase;

  [aria-disabled='true'] {
    cursor: not-allowed;
    pointer-events: none;
  }

  &:hover {
    background-color: ${(props) => props.color};
    color: ${(props) => (shouldUseWhiteText(props.color) ? 'white' : 'black')};
  }
`
